import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';

const StyledSwitchDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
  }
  
  &.SwitchDialog {
    .DialogActions {
      padding: ${props => props.theme.spacing(2)};
    }

    .DialogContent {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding: 0;

      .ActionList-list {
        padding: ${props => props.theme.spacing(2)} !important;
        scroll-margin-top: ${props => props.theme.spacing(2)};
        scroll-margin-bottom: ${props => props.theme.spacing(2)};
        
        .ListItem {
          &:not(:first-child, :last-child) {
            scroll-margin-top: ${props => props.theme.spacing(0.5)};
            scroll-margin-bottom: ${props => props.theme.spacing(0.5)};
          }
        }
      }
    }
    
    &:not(:has(.DialogFooter)), &:not(:has(.DialogFooter > *:not(.DialogFooter-info), .DialogFooter-info > *)) {
      .DialogContent {
        padding-bottom: ${props => props.theme.spacing(2)};

        .ActionList-list {
          padding-bottom: 0 !important;
          scroll-margin-bottom: 0 !important;
          
          .ListItem {
            &:not(:last-child) {
              scroll-margin-bottom: 0 !important;
            }
          }
        }
      }
    }
    
    .DialogFooter:not(:has(> *:not(.DialogFooter-info), .DialogFooter-info > *)) {
        display: none;
    }
  }
  
  ${ComponentStyles}
`;

StyledSwitchDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledSwitchDialog;
